// extracted by mini-css-extract-plugin
export default {"item":"carousel_item__FrqFb","caption":"carousel_caption__GsqZl"};